import { Injectable } from '@angular/core';
import { UserInfoService } from '../user/user-info.service';
import { HttpClient } from '@angular/common/http';
import * as Rx from 'rxjs';
import { map } from 'rxjs/operators';

export interface ICacheItem {
	url: string,
	personGuid: string,
	cache: any
}

@Injectable({
	providedIn: 'root'
})
export class CacheService {
	constructor(
		private userInfo: UserInfoService,
		private http: HttpClient
	) { }

	private cachedItems: ICacheItem[] = [];

	get<T>(anonymous: boolean, url: string): Rx.Observable<T> {
		let found = this.cachedItems.find(x => x.url === url);
		// return cache only if the login is same person
		if (found != undefined) {
			if (anonymous && found.personGuid === "") {
				return Rx.of(JSON.parse(JSON.stringify(found.cache)) as T);
			}
			else if (!anonymous && found.personGuid === this.userInfo.getProfile().PersonGuid) {
				return Rx.of(JSON.parse(JSON.stringify(found.cache)) as T);
			}
		}

		if (anonymous) {
			return this.http.get<T>(url)
				.pipe(map(
					(item: T) => {
						this.cachedItems.push({
							url: url,
							personGuid: "",
							cache: item
						});
						return JSON.parse(JSON.stringify(item));
					}
				));
		}
		else {
			return this.http.get<T>(
				url,
				{
					withCredentials: true,
					headers: { 'Authorization': this.userInfo.authHeader(false) }
				}
			).pipe(map(
				(item: T) => {
					this.cachedItems.push({
						url: url,
						personGuid: this.userInfo.getProfile().PersonGuid,
						cache: item
					});
					return JSON.parse(JSON.stringify(item));
				}
			));
		}
	}

	remove(url: string): void {
		this.cachedItems = this.cachedItems.filter(x => x.url !== url);
	}

	clear(): void {
		this.cachedItems = [];
	}
}
